<template>
  <el-dialog
    :title="$t('cityArea.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align: center;">
      <p>{{ $t('cityArea.confirmDeleteArea') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cityArea.cancel') }}</el-button>
      <el-button type="primary" @click="deleteCityArea">{{ $t('cityArea.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteCityArea } from '@/api/shop/cityAreaApi'

export default {
  name: 'DeleteCityArea',
  data() {
    return {
      dialogVisible: false,
      deleteCityAreaInfo: {}
    }
  },
  methods: {
    open(params) {
      this.deleteCityAreaInfo = { ...params }
      this.dialogVisible = true
    },
    handleClose() {
      this.clearDeleteCityAreaInfo()
    },
    deleteCityArea() {
      deleteCityArea(this.deleteCityAreaInfo).then(response => {
        console.log(response)
        this.$message.success(this.$t('cityArea.deleteSuccess'))
        this.dialogVisible = false
        this.clearDeleteCityAreaInfo()
        this.$emit('success')
      }).catch(error => {
        console.error('删除地区失败:', error)
        this.$message.error(this.$t('cityArea.deleteFailed'))
      })
    },
    clearDeleteCityAreaInfo() {
      this.deleteCityAreaInfo = {}
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: center;
}
</style>